import React from 'react';
import { useParams } from 'react-router-dom';
import '../styles/MobilePage.css';

export default function MobilePage() {
  const { roomId } = useParams();
  
  return (
    <div className="mobile-container">
      <h2>Mobile Chat Interface</h2>
      <p>Room: {roomId}</p>
      {/* Simplified mobile interface components */}
    </div>
  );
}
